module.exports = __webpack_public_path__ + "3c46f46d8ab52a829fb4a7f74969a6b3.png";